import React from "react";
import { AlertContext, DialogContext, BackdropContext, DrawerContext, CartListCountContect } from "../contexts";

const withAllContexts = (Component) => (props) => {
  const alert = React.useContext(AlertContext);
  const dialog = React.useContext(DialogContext);
  const backDrop = React.useContext(BackdropContext);
  const drawer = React.useContext(DrawerContext);
  const cartCount = React.useContext(CartListCountContect);

  return (
    <Component {...props} alert={alert} dialog={dialog} backDrop={backDrop} drawer={drawer} cartCount={cartCount} >
      {props.children}
    </Component>
  );
};

export default withAllContexts;
